import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { updateGg1Analyst } from "../../store/GG1-Crud/actions";
import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import moment from "moment";
import { advanceSearch } from "../../_helper/services/advanceSearchv2";
import "../../Components/Workflow/custom.css";
// import { getBBMRAnalyst } from "../Create Transaction/slices/ggTrackSlice";

const columns = [
  {
    field: "EmployeeID",
    header: "Dependent ID",
    width: "130px",
  },
  {
    field: "EmployeeName_LFM",
    header: "Dependent Name",
    width: "200px",
  },
  {
    field: "DivisionName",
    header: "Department",
    width: "300px",
  },
  {
    field: "TotalAssigned",
    header: "Total Assigned",
    width: "150px",
  },
];
function DependentsPopup({ open, onClose, setOpen, EmployeeID, HrControl }) {
  let {
    columns,
    loadingSearch,
    searchParameter,
    ColumnsSorted,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const { searchResultsV2 } = useSelector(
    (state) => state.advanceSearchv2Reducer
  );
  const { gg1loading } = useSelector(
    (state) => state.GG1Reducer
  );
  const [dependentList, setDependentList] = useState([]);

  const [loading, setLoading] = useState(false);
  const getDependentList = async () => {
    const payload = {
      tableName: "vw_benefits_dependents",
      searchParams: "[]",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "",
      additionalWhere: `DentalSubscriberID = ${EmployeeID} or HealthSubscriberID = ${EmployeeID}`,
      location: "Benefits-global",
    };
    try {
      setLoading(true);
      const response = await advanceSearch(payload, 'Benefits');
      const { results } = response;
      setDependentList(results);
      console.log("sdfdsafdsfdsfsa: ", response)
      setLoading(false);
      // let gradeData = gradeList?.results.map((item) => {
      //   return item.To_Grade;
      // });

      // if(gradeData?.length){
      //   setPayGradeDataByPos(gradeData);
      // }else{
      //   setPayGradeDataByPos([]);
      // }
      // setLoading(false);
    } catch (error) {
      setLoading(false);
      // setLoading(false);
    }
  }
  useEffect(() => {
    getDependentList();
  }, []);

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        onClose={onClose}
        aria-labelledby="dependent-dialog-title"
        aria-describedby="dependent-dialog-description"
        width={800}
      >
        {/* <Dialog title="Assign Analyst" onClose={onClose} width={400} visible={open}></Dialog> */}
        <DialogTitle id="dependent-dialog-title" className="mt-2">
          Dependents List of Subscriber {EmployeeID}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 40,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div>
            <table className="rwd-table">
              <tr className="bg-primary">
                <th>Name</th>
                <th>DOB</th>
                <th>Relation</th>
                <th>Health</th>
                <th>Dental</th>
              </tr>
              {!loading && dependentList?.length ? dependentList?.map((data) => {
                return (
                  <>
                    <tr>
                      <td>{data?.LastName} {data?.FirstName} {data?.MiddleName}</td>
                      <td>{moment(data?.DOB).format('MM/DD/YYYY')}</td>
                      <td>{data?.Relation}</td>
                      <td>{data?.HealthSubscriberID ? "Subscribed" : ""}</td>
                      <td>{data?.DentalSubscriberID ? "Subscribed" : ""}</td>
                    </tr>
                  </>
                )
              })
                : !loading && dependentList && dependentList?.length == 0 ?
                  <span>No Data Found!</span>
                  : null}

            </table>
          </div>
        </DialogContent>

      </Dialog>
    </div>
  );
}

export default DependentsPopup;
